/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedTravelersRouteImport } from './routes/_authenticated/travelers'
import { Route as AuthenticatedHotelsExternalRouteImport } from './routes/_authenticated/hotelsExternal'
import { Route as AuthenticatedFlightsExternalRouteImport } from './routes/_authenticated/flightsExternal'
import { Route as AuthenticatedChatRouteImport } from './routes/_authenticated/chat'
import { Route as AuthenticatedBookingsRouteImport } from './routes/_authenticated/bookings'
import { Route as AuthenticatedHotelsRouteImport } from './routes/_authenticated/_hotels'
import { Route as AuthenticatedFlightsRouteImport } from './routes/_authenticated/_flights'
import { Route as AuthenticatedHotelsHotelOfferRouteImport } from './routes/_authenticated/_hotels/_hotel-offer'
import { Route as AuthenticatedFlightsFlightOfferRouteImport } from './routes/_authenticated/_flights/_flight-offer'
import { Route as AuthenticatedTripsTripIdRouteRouteImport } from './routes/_authenticated/trips/$tripId/route'
import { Route as AuthenticatedTripsTripIdIndexRouteImport } from './routes/_authenticated/trips/$tripId/index'
import { Route as AuthenticatedTripsTripIdTravellersRouteImport } from './routes/_authenticated/trips/$tripId/travellers'
import { Route as AuthenticatedTripsTripIdSummaryRouteImport } from './routes/_authenticated/trips/$tripId/summary'
import { Route as AuthenticatedTripsTripIdSuccessRouteImport } from './routes/_authenticated/trips/$tripId/success'
import { Route as AuthenticatedTripsTripIdBookingRouteImport } from './routes/_authenticated/trips/$tripId/booking'
import { Route as AuthenticatedBookingsScopeIdRouteImport } from './routes/_authenticated/bookings_.$scope.$id'
import { Route as AuthenticatedHotelsHotelsListRouteImport } from './routes/_authenticated/_hotels/hotels.list'
import { Route as AuthenticatedHotelsHotelOfferHotelsIdRouteImport } from './routes/_authenticated/_hotels/_hotel-offer/hotels.$id'
import { Route as AuthenticatedFlightsFlightsReturnListRouteImport } from './routes/_authenticated/_flights/flights.return/list'
import { Route as AuthenticatedFlightsFlightsDepartureListRouteImport } from './routes/_authenticated/_flights/flights.departure/list'
import { Route as AuthenticatedHotelsHotelOfferHotelsIdTravelersRouteImport } from './routes/_authenticated/_hotels/_hotel-offer/hotels.$id.travelers'
import { Route as AuthenticatedHotelsHotelOfferHotelsIdSummaryRouteImport } from './routes/_authenticated/_hotels/_hotel-offer/hotels.$id.summary'
import { Route as AuthenticatedHotelsHotelOfferHotelsIdRoomsRouteImport } from './routes/_authenticated/_hotels/_hotel-offer/hotels.$id.rooms'
import { Route as AuthenticatedHotelsHotelOfferHotelsIdDetailsRouteImport } from './routes/_authenticated/_hotels/_hotel-offer/hotels.$id.details'
import { Route as AuthenticatedHotelsHotelOfferHotelsIdConfirmationRouteImport } from './routes/_authenticated/_hotels/_hotel-offer/hotels.$id.confirmation'
import { Route as AuthenticatedHotelsHotelOfferHotelsIdDetailsImagesRouteImport } from './routes/_authenticated/_hotels/_hotel-offer/hotels.$id.details_.images'
import { Route as AuthenticatedHotelsHotelOfferHotelsIdRoomsRoomTokenImagesRouteImport } from './routes/_authenticated/_hotels/_hotel-offer/hotels.$id.rooms_.$roomToken.images'
import { Route as AuthenticatedHotelsHotelOfferHotelsIdDetailsImagesFullscreenRouteImport } from './routes/_authenticated/_hotels/_hotel-offer/hotels.$id.details_.images_.fullscreen'
import { Route as AuthenticatedFlightsFlightOfferFlightsOfferIdStepFinalRouteImport } from './routes/_authenticated/_flights/_flight-offer/flights.offer.$id.step.final'
import { Route as AuthenticatedFlightsFlightOfferFlightsOfferIdStep3RouteImport } from './routes/_authenticated/_flights/_flight-offer/flights.offer.$id.step.3'
import { Route as AuthenticatedFlightsFlightOfferFlightsOfferIdStep2RouteImport } from './routes/_authenticated/_flights/_flight-offer/flights.offer.$id.step.2'
import { Route as AuthenticatedFlightsFlightOfferFlightsOfferIdStep1RouteImport } from './routes/_authenticated/_flights/_flight-offer/flights.offer.$id.step.1'
import { Route as AuthenticatedHotelsHotelOfferHotelsIdRoomsRoomTokenImagesFullscreenRouteImport } from './routes/_authenticated/_hotels/_hotel-offer/hotels.$id.rooms_.$roomToken.images_.fullscreen'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTravelersRoute = AuthenticatedTravelersRouteImport.update({
  id: '/travelers',
  path: '/travelers',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHotelsExternalRoute =
  AuthenticatedHotelsExternalRouteImport.update({
    id: '/hotelsExternal',
    path: '/hotelsExternal',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFlightsExternalRoute =
  AuthenticatedFlightsExternalRouteImport.update({
    id: '/flightsExternal',
    path: '/flightsExternal',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedChatRoute = AuthenticatedChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBookingsRoute = AuthenticatedBookingsRouteImport.update({
  id: '/bookings',
  path: '/bookings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHotelsRoute = AuthenticatedHotelsRouteImport.update({
  id: '/_hotels',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFlightsRoute = AuthenticatedFlightsRouteImport.update({
  id: '/_flights',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHotelsHotelOfferRoute =
  AuthenticatedHotelsHotelOfferRouteImport.update({
    id: '/_hotel-offer',
    getParentRoute: () => AuthenticatedHotelsRoute,
  } as any)
const AuthenticatedFlightsFlightOfferRoute =
  AuthenticatedFlightsFlightOfferRouteImport.update({
    id: '/_flight-offer',
    getParentRoute: () => AuthenticatedFlightsRoute,
  } as any)
const AuthenticatedTripsTripIdRouteRoute =
  AuthenticatedTripsTripIdRouteRouteImport.update({
    id: '/trips/$tripId',
    path: '/trips/$tripId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTripsTripIdIndexRoute =
  AuthenticatedTripsTripIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTripsTripIdRouteRoute,
  } as any)
const AuthenticatedTripsTripIdTravellersRoute =
  AuthenticatedTripsTripIdTravellersRouteImport.update({
    id: '/travellers',
    path: '/travellers',
    getParentRoute: () => AuthenticatedTripsTripIdRouteRoute,
  } as any)
const AuthenticatedTripsTripIdSummaryRoute =
  AuthenticatedTripsTripIdSummaryRouteImport.update({
    id: '/summary',
    path: '/summary',
    getParentRoute: () => AuthenticatedTripsTripIdRouteRoute,
  } as any)
const AuthenticatedTripsTripIdSuccessRoute =
  AuthenticatedTripsTripIdSuccessRouteImport.update({
    id: '/success',
    path: '/success',
    getParentRoute: () => AuthenticatedTripsTripIdRouteRoute,
  } as any)
const AuthenticatedTripsTripIdBookingRoute =
  AuthenticatedTripsTripIdBookingRouteImport.update({
    id: '/booking',
    path: '/booking',
    getParentRoute: () => AuthenticatedTripsTripIdRouteRoute,
  } as any)
const AuthenticatedBookingsScopeIdRoute =
  AuthenticatedBookingsScopeIdRouteImport.update({
    id: '/bookings_/$scope/$id',
    path: '/bookings/$scope/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHotelsHotelsListRoute =
  AuthenticatedHotelsHotelsListRouteImport.update({
    id: '/hotels/list',
    path: '/hotels/list',
    getParentRoute: () => AuthenticatedHotelsRoute,
  } as any)
const AuthenticatedHotelsHotelOfferHotelsIdRoute =
  AuthenticatedHotelsHotelOfferHotelsIdRouteImport.update({
    id: '/hotels/$id',
    path: '/hotels/$id',
    getParentRoute: () => AuthenticatedHotelsHotelOfferRoute,
  } as any)
const AuthenticatedFlightsFlightsReturnListRoute =
  AuthenticatedFlightsFlightsReturnListRouteImport.update({
    id: '/flights/return/list',
    path: '/flights/return/list',
    getParentRoute: () => AuthenticatedFlightsRoute,
  } as any)
const AuthenticatedFlightsFlightsDepartureListRoute =
  AuthenticatedFlightsFlightsDepartureListRouteImport.update({
    id: '/flights/departure/list',
    path: '/flights/departure/list',
    getParentRoute: () => AuthenticatedFlightsRoute,
  } as any)
const AuthenticatedHotelsHotelOfferHotelsIdTravelersRoute =
  AuthenticatedHotelsHotelOfferHotelsIdTravelersRouteImport.update({
    id: '/travelers',
    path: '/travelers',
    getParentRoute: () => AuthenticatedHotelsHotelOfferHotelsIdRoute,
  } as any)
const AuthenticatedHotelsHotelOfferHotelsIdSummaryRoute =
  AuthenticatedHotelsHotelOfferHotelsIdSummaryRouteImport.update({
    id: '/summary',
    path: '/summary',
    getParentRoute: () => AuthenticatedHotelsHotelOfferHotelsIdRoute,
  } as any)
const AuthenticatedHotelsHotelOfferHotelsIdRoomsRoute =
  AuthenticatedHotelsHotelOfferHotelsIdRoomsRouteImport.update({
    id: '/rooms',
    path: '/rooms',
    getParentRoute: () => AuthenticatedHotelsHotelOfferHotelsIdRoute,
  } as any)
const AuthenticatedHotelsHotelOfferHotelsIdDetailsRoute =
  AuthenticatedHotelsHotelOfferHotelsIdDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => AuthenticatedHotelsHotelOfferHotelsIdRoute,
  } as any)
const AuthenticatedHotelsHotelOfferHotelsIdConfirmationRoute =
  AuthenticatedHotelsHotelOfferHotelsIdConfirmationRouteImport.update({
    id: '/confirmation',
    path: '/confirmation',
    getParentRoute: () => AuthenticatedHotelsHotelOfferHotelsIdRoute,
  } as any)
const AuthenticatedHotelsHotelOfferHotelsIdDetailsImagesRoute =
  AuthenticatedHotelsHotelOfferHotelsIdDetailsImagesRouteImport.update({
    id: '/details_/images',
    path: '/details/images',
    getParentRoute: () => AuthenticatedHotelsHotelOfferHotelsIdRoute,
  } as any)
const AuthenticatedHotelsHotelOfferHotelsIdRoomsRoomTokenImagesRoute =
  AuthenticatedHotelsHotelOfferHotelsIdRoomsRoomTokenImagesRouteImport.update({
    id: '/rooms_/$roomToken/images',
    path: '/rooms/$roomToken/images',
    getParentRoute: () => AuthenticatedHotelsHotelOfferHotelsIdRoute,
  } as any)
const AuthenticatedHotelsHotelOfferHotelsIdDetailsImagesFullscreenRoute =
  AuthenticatedHotelsHotelOfferHotelsIdDetailsImagesFullscreenRouteImport.update(
    {
      id: '/details_/images_/fullscreen',
      path: '/details/images/fullscreen',
      getParentRoute: () => AuthenticatedHotelsHotelOfferHotelsIdRoute,
    } as any,
  )
const AuthenticatedFlightsFlightOfferFlightsOfferIdStepFinalRoute =
  AuthenticatedFlightsFlightOfferFlightsOfferIdStepFinalRouteImport.update({
    id: '/flights/offer/$id/step/final',
    path: '/flights/offer/$id/step/final',
    getParentRoute: () => AuthenticatedFlightsFlightOfferRoute,
  } as any)
const AuthenticatedFlightsFlightOfferFlightsOfferIdStep3Route =
  AuthenticatedFlightsFlightOfferFlightsOfferIdStep3RouteImport.update({
    id: '/flights/offer/$id/step/3',
    path: '/flights/offer/$id/step/3',
    getParentRoute: () => AuthenticatedFlightsFlightOfferRoute,
  } as any)
const AuthenticatedFlightsFlightOfferFlightsOfferIdStep2Route =
  AuthenticatedFlightsFlightOfferFlightsOfferIdStep2RouteImport.update({
    id: '/flights/offer/$id/step/2',
    path: '/flights/offer/$id/step/2',
    getParentRoute: () => AuthenticatedFlightsFlightOfferRoute,
  } as any)
const AuthenticatedFlightsFlightOfferFlightsOfferIdStep1Route =
  AuthenticatedFlightsFlightOfferFlightsOfferIdStep1RouteImport.update({
    id: '/flights/offer/$id/step/1',
    path: '/flights/offer/$id/step/1',
    getParentRoute: () => AuthenticatedFlightsFlightOfferRoute,
  } as any)
const AuthenticatedHotelsHotelOfferHotelsIdRoomsRoomTokenImagesFullscreenRoute =
  AuthenticatedHotelsHotelOfferHotelsIdRoomsRoomTokenImagesFullscreenRouteImport.update(
    {
      id: '/rooms_/$roomToken/images_/fullscreen',
      path: '/rooms/$roomToken/images/fullscreen',
      getParentRoute: () => AuthenticatedHotelsHotelOfferHotelsIdRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/bookings': typeof AuthenticatedBookingsRoute
  '/chat': typeof AuthenticatedChatRoute
  '/flightsExternal': typeof AuthenticatedFlightsExternalRoute
  '/hotelsExternal': typeof AuthenticatedHotelsExternalRoute
  '/travelers': typeof AuthenticatedTravelersRoute
  '/': typeof AuthenticatedIndexRoute
  '/trips/$tripId': typeof AuthenticatedTripsTripIdRouteRouteWithChildren
  '/hotels/list': typeof AuthenticatedHotelsHotelsListRoute
  '/bookings/$scope/$id': typeof AuthenticatedBookingsScopeIdRoute
  '/trips/$tripId/booking': typeof AuthenticatedTripsTripIdBookingRoute
  '/trips/$tripId/success': typeof AuthenticatedTripsTripIdSuccessRoute
  '/trips/$tripId/summary': typeof AuthenticatedTripsTripIdSummaryRoute
  '/trips/$tripId/travellers': typeof AuthenticatedTripsTripIdTravellersRoute
  '/trips/$tripId/': typeof AuthenticatedTripsTripIdIndexRoute
  '/flights/departure/list': typeof AuthenticatedFlightsFlightsDepartureListRoute
  '/flights/return/list': typeof AuthenticatedFlightsFlightsReturnListRoute
  '/hotels/$id': typeof AuthenticatedHotelsHotelOfferHotelsIdRouteWithChildren
  '/hotels/$id/confirmation': typeof AuthenticatedHotelsHotelOfferHotelsIdConfirmationRoute
  '/hotels/$id/details': typeof AuthenticatedHotelsHotelOfferHotelsIdDetailsRoute
  '/hotels/$id/rooms': typeof AuthenticatedHotelsHotelOfferHotelsIdRoomsRoute
  '/hotels/$id/summary': typeof AuthenticatedHotelsHotelOfferHotelsIdSummaryRoute
  '/hotels/$id/travelers': typeof AuthenticatedHotelsHotelOfferHotelsIdTravelersRoute
  '/hotels/$id/details/images': typeof AuthenticatedHotelsHotelOfferHotelsIdDetailsImagesRoute
  '/flights/offer/$id/step/1': typeof AuthenticatedFlightsFlightOfferFlightsOfferIdStep1Route
  '/flights/offer/$id/step/2': typeof AuthenticatedFlightsFlightOfferFlightsOfferIdStep2Route
  '/flights/offer/$id/step/3': typeof AuthenticatedFlightsFlightOfferFlightsOfferIdStep3Route
  '/flights/offer/$id/step/final': typeof AuthenticatedFlightsFlightOfferFlightsOfferIdStepFinalRoute
  '/hotels/$id/details/images/fullscreen': typeof AuthenticatedHotelsHotelOfferHotelsIdDetailsImagesFullscreenRoute
  '/hotels/$id/rooms/$roomToken/images': typeof AuthenticatedHotelsHotelOfferHotelsIdRoomsRoomTokenImagesRoute
  '/hotels/$id/rooms/$roomToken/images/fullscreen': typeof AuthenticatedHotelsHotelOfferHotelsIdRoomsRoomTokenImagesFullscreenRoute
}
export interface FileRoutesByTo {
  '/bookings': typeof AuthenticatedBookingsRoute
  '/chat': typeof AuthenticatedChatRoute
  '/flightsExternal': typeof AuthenticatedFlightsExternalRoute
  '/hotelsExternal': typeof AuthenticatedHotelsExternalRoute
  '/travelers': typeof AuthenticatedTravelersRoute
  '/': typeof AuthenticatedIndexRoute
  '/hotels/list': typeof AuthenticatedHotelsHotelsListRoute
  '/bookings/$scope/$id': typeof AuthenticatedBookingsScopeIdRoute
  '/trips/$tripId/booking': typeof AuthenticatedTripsTripIdBookingRoute
  '/trips/$tripId/success': typeof AuthenticatedTripsTripIdSuccessRoute
  '/trips/$tripId/summary': typeof AuthenticatedTripsTripIdSummaryRoute
  '/trips/$tripId/travellers': typeof AuthenticatedTripsTripIdTravellersRoute
  '/trips/$tripId': typeof AuthenticatedTripsTripIdIndexRoute
  '/flights/departure/list': typeof AuthenticatedFlightsFlightsDepartureListRoute
  '/flights/return/list': typeof AuthenticatedFlightsFlightsReturnListRoute
  '/hotels/$id': typeof AuthenticatedHotelsHotelOfferHotelsIdRouteWithChildren
  '/hotels/$id/confirmation': typeof AuthenticatedHotelsHotelOfferHotelsIdConfirmationRoute
  '/hotels/$id/details': typeof AuthenticatedHotelsHotelOfferHotelsIdDetailsRoute
  '/hotels/$id/rooms': typeof AuthenticatedHotelsHotelOfferHotelsIdRoomsRoute
  '/hotels/$id/summary': typeof AuthenticatedHotelsHotelOfferHotelsIdSummaryRoute
  '/hotels/$id/travelers': typeof AuthenticatedHotelsHotelOfferHotelsIdTravelersRoute
  '/hotels/$id/details/images': typeof AuthenticatedHotelsHotelOfferHotelsIdDetailsImagesRoute
  '/flights/offer/$id/step/1': typeof AuthenticatedFlightsFlightOfferFlightsOfferIdStep1Route
  '/flights/offer/$id/step/2': typeof AuthenticatedFlightsFlightOfferFlightsOfferIdStep2Route
  '/flights/offer/$id/step/3': typeof AuthenticatedFlightsFlightOfferFlightsOfferIdStep3Route
  '/flights/offer/$id/step/final': typeof AuthenticatedFlightsFlightOfferFlightsOfferIdStepFinalRoute
  '/hotels/$id/details/images/fullscreen': typeof AuthenticatedHotelsHotelOfferHotelsIdDetailsImagesFullscreenRoute
  '/hotels/$id/rooms/$roomToken/images': typeof AuthenticatedHotelsHotelOfferHotelsIdRoomsRoomTokenImagesRoute
  '/hotels/$id/rooms/$roomToken/images/fullscreen': typeof AuthenticatedHotelsHotelOfferHotelsIdRoomsRoomTokenImagesFullscreenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/_flights': typeof AuthenticatedFlightsRouteWithChildren
  '/_authenticated/_hotels': typeof AuthenticatedHotelsRouteWithChildren
  '/_authenticated/bookings': typeof AuthenticatedBookingsRoute
  '/_authenticated/chat': typeof AuthenticatedChatRoute
  '/_authenticated/flightsExternal': typeof AuthenticatedFlightsExternalRoute
  '/_authenticated/hotelsExternal': typeof AuthenticatedHotelsExternalRoute
  '/_authenticated/travelers': typeof AuthenticatedTravelersRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/trips/$tripId': typeof AuthenticatedTripsTripIdRouteRouteWithChildren
  '/_authenticated/_flights/_flight-offer': typeof AuthenticatedFlightsFlightOfferRouteWithChildren
  '/_authenticated/_hotels/_hotel-offer': typeof AuthenticatedHotelsHotelOfferRouteWithChildren
  '/_authenticated/_hotels/hotels/list': typeof AuthenticatedHotelsHotelsListRoute
  '/_authenticated/bookings_/$scope/$id': typeof AuthenticatedBookingsScopeIdRoute
  '/_authenticated/trips/$tripId/booking': typeof AuthenticatedTripsTripIdBookingRoute
  '/_authenticated/trips/$tripId/success': typeof AuthenticatedTripsTripIdSuccessRoute
  '/_authenticated/trips/$tripId/summary': typeof AuthenticatedTripsTripIdSummaryRoute
  '/_authenticated/trips/$tripId/travellers': typeof AuthenticatedTripsTripIdTravellersRoute
  '/_authenticated/trips/$tripId/': typeof AuthenticatedTripsTripIdIndexRoute
  '/_authenticated/_flights/flights/departure/list': typeof AuthenticatedFlightsFlightsDepartureListRoute
  '/_authenticated/_flights/flights/return/list': typeof AuthenticatedFlightsFlightsReturnListRoute
  '/_authenticated/_hotels/_hotel-offer/hotels/$id': typeof AuthenticatedHotelsHotelOfferHotelsIdRouteWithChildren
  '/_authenticated/_hotels/_hotel-offer/hotels/$id/confirmation': typeof AuthenticatedHotelsHotelOfferHotelsIdConfirmationRoute
  '/_authenticated/_hotels/_hotel-offer/hotels/$id/details': typeof AuthenticatedHotelsHotelOfferHotelsIdDetailsRoute
  '/_authenticated/_hotels/_hotel-offer/hotels/$id/rooms': typeof AuthenticatedHotelsHotelOfferHotelsIdRoomsRoute
  '/_authenticated/_hotels/_hotel-offer/hotels/$id/summary': typeof AuthenticatedHotelsHotelOfferHotelsIdSummaryRoute
  '/_authenticated/_hotels/_hotel-offer/hotels/$id/travelers': typeof AuthenticatedHotelsHotelOfferHotelsIdTravelersRoute
  '/_authenticated/_hotels/_hotel-offer/hotels/$id/details_/images': typeof AuthenticatedHotelsHotelOfferHotelsIdDetailsImagesRoute
  '/_authenticated/_flights/_flight-offer/flights/offer/$id/step/1': typeof AuthenticatedFlightsFlightOfferFlightsOfferIdStep1Route
  '/_authenticated/_flights/_flight-offer/flights/offer/$id/step/2': typeof AuthenticatedFlightsFlightOfferFlightsOfferIdStep2Route
  '/_authenticated/_flights/_flight-offer/flights/offer/$id/step/3': typeof AuthenticatedFlightsFlightOfferFlightsOfferIdStep3Route
  '/_authenticated/_flights/_flight-offer/flights/offer/$id/step/final': typeof AuthenticatedFlightsFlightOfferFlightsOfferIdStepFinalRoute
  '/_authenticated/_hotels/_hotel-offer/hotels/$id/details_/images_/fullscreen': typeof AuthenticatedHotelsHotelOfferHotelsIdDetailsImagesFullscreenRoute
  '/_authenticated/_hotels/_hotel-offer/hotels/$id/rooms_/$roomToken/images': typeof AuthenticatedHotelsHotelOfferHotelsIdRoomsRoomTokenImagesRoute
  '/_authenticated/_hotels/_hotel-offer/hotels/$id/rooms_/$roomToken/images_/fullscreen': typeof AuthenticatedHotelsHotelOfferHotelsIdRoomsRoomTokenImagesFullscreenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/bookings'
    | '/chat'
    | '/flightsExternal'
    | '/hotelsExternal'
    | '/travelers'
    | '/'
    | '/trips/$tripId'
    | '/hotels/list'
    | '/bookings/$scope/$id'
    | '/trips/$tripId/booking'
    | '/trips/$tripId/success'
    | '/trips/$tripId/summary'
    | '/trips/$tripId/travellers'
    | '/trips/$tripId/'
    | '/flights/departure/list'
    | '/flights/return/list'
    | '/hotels/$id'
    | '/hotels/$id/confirmation'
    | '/hotels/$id/details'
    | '/hotels/$id/rooms'
    | '/hotels/$id/summary'
    | '/hotels/$id/travelers'
    | '/hotels/$id/details/images'
    | '/flights/offer/$id/step/1'
    | '/flights/offer/$id/step/2'
    | '/flights/offer/$id/step/3'
    | '/flights/offer/$id/step/final'
    | '/hotels/$id/details/images/fullscreen'
    | '/hotels/$id/rooms/$roomToken/images'
    | '/hotels/$id/rooms/$roomToken/images/fullscreen'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/bookings'
    | '/chat'
    | '/flightsExternal'
    | '/hotelsExternal'
    | '/travelers'
    | '/'
    | '/hotels/list'
    | '/bookings/$scope/$id'
    | '/trips/$tripId/booking'
    | '/trips/$tripId/success'
    | '/trips/$tripId/summary'
    | '/trips/$tripId/travellers'
    | '/trips/$tripId'
    | '/flights/departure/list'
    | '/flights/return/list'
    | '/hotels/$id'
    | '/hotels/$id/confirmation'
    | '/hotels/$id/details'
    | '/hotels/$id/rooms'
    | '/hotels/$id/summary'
    | '/hotels/$id/travelers'
    | '/hotels/$id/details/images'
    | '/flights/offer/$id/step/1'
    | '/flights/offer/$id/step/2'
    | '/flights/offer/$id/step/3'
    | '/flights/offer/$id/step/final'
    | '/hotels/$id/details/images/fullscreen'
    | '/hotels/$id/rooms/$roomToken/images'
    | '/hotels/$id/rooms/$roomToken/images/fullscreen'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_authenticated/_flights'
    | '/_authenticated/_hotels'
    | '/_authenticated/bookings'
    | '/_authenticated/chat'
    | '/_authenticated/flightsExternal'
    | '/_authenticated/hotelsExternal'
    | '/_authenticated/travelers'
    | '/_authenticated/'
    | '/_authenticated/trips/$tripId'
    | '/_authenticated/_flights/_flight-offer'
    | '/_authenticated/_hotels/_hotel-offer'
    | '/_authenticated/_hotels/hotels/list'
    | '/_authenticated/bookings_/$scope/$id'
    | '/_authenticated/trips/$tripId/booking'
    | '/_authenticated/trips/$tripId/success'
    | '/_authenticated/trips/$tripId/summary'
    | '/_authenticated/trips/$tripId/travellers'
    | '/_authenticated/trips/$tripId/'
    | '/_authenticated/_flights/flights/departure/list'
    | '/_authenticated/_flights/flights/return/list'
    | '/_authenticated/_hotels/_hotel-offer/hotels/$id'
    | '/_authenticated/_hotels/_hotel-offer/hotels/$id/confirmation'
    | '/_authenticated/_hotels/_hotel-offer/hotels/$id/details'
    | '/_authenticated/_hotels/_hotel-offer/hotels/$id/rooms'
    | '/_authenticated/_hotels/_hotel-offer/hotels/$id/summary'
    | '/_authenticated/_hotels/_hotel-offer/hotels/$id/travelers'
    | '/_authenticated/_hotels/_hotel-offer/hotels/$id/details_/images'
    | '/_authenticated/_flights/_flight-offer/flights/offer/$id/step/1'
    | '/_authenticated/_flights/_flight-offer/flights/offer/$id/step/2'
    | '/_authenticated/_flights/_flight-offer/flights/offer/$id/step/3'
    | '/_authenticated/_flights/_flight-offer/flights/offer/$id/step/final'
    | '/_authenticated/_hotels/_hotel-offer/hotels/$id/details_/images_/fullscreen'
    | '/_authenticated/_hotels/_hotel-offer/hotels/$id/rooms_/$roomToken/images'
    | '/_authenticated/_hotels/_hotel-offer/hotels/$id/rooms_/$roomToken/images_/fullscreen'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/travelers': {
      id: '/_authenticated/travelers'
      path: '/travelers'
      fullPath: '/travelers'
      preLoaderRoute: typeof AuthenticatedTravelersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hotelsExternal': {
      id: '/_authenticated/hotelsExternal'
      path: '/hotelsExternal'
      fullPath: '/hotelsExternal'
      preLoaderRoute: typeof AuthenticatedHotelsExternalRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/flightsExternal': {
      id: '/_authenticated/flightsExternal'
      path: '/flightsExternal'
      fullPath: '/flightsExternal'
      preLoaderRoute: typeof AuthenticatedFlightsExternalRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/chat': {
      id: '/_authenticated/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof AuthenticatedChatRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/bookings': {
      id: '/_authenticated/bookings'
      path: '/bookings'
      fullPath: '/bookings'
      preLoaderRoute: typeof AuthenticatedBookingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_hotels': {
      id: '/_authenticated/_hotels'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedHotelsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_flights': {
      id: '/_authenticated/_flights'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedFlightsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_hotels/_hotel-offer': {
      id: '/_authenticated/_hotels/_hotel-offer'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedHotelsHotelOfferRouteImport
      parentRoute: typeof AuthenticatedHotelsRoute
    }
    '/_authenticated/_flights/_flight-offer': {
      id: '/_authenticated/_flights/_flight-offer'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedFlightsFlightOfferRouteImport
      parentRoute: typeof AuthenticatedFlightsRoute
    }
    '/_authenticated/trips/$tripId': {
      id: '/_authenticated/trips/$tripId'
      path: '/trips/$tripId'
      fullPath: '/trips/$tripId'
      preLoaderRoute: typeof AuthenticatedTripsTripIdRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/trips/$tripId/': {
      id: '/_authenticated/trips/$tripId/'
      path: '/'
      fullPath: '/trips/$tripId/'
      preLoaderRoute: typeof AuthenticatedTripsTripIdIndexRouteImport
      parentRoute: typeof AuthenticatedTripsTripIdRouteRoute
    }
    '/_authenticated/trips/$tripId/travellers': {
      id: '/_authenticated/trips/$tripId/travellers'
      path: '/travellers'
      fullPath: '/trips/$tripId/travellers'
      preLoaderRoute: typeof AuthenticatedTripsTripIdTravellersRouteImport
      parentRoute: typeof AuthenticatedTripsTripIdRouteRoute
    }
    '/_authenticated/trips/$tripId/summary': {
      id: '/_authenticated/trips/$tripId/summary'
      path: '/summary'
      fullPath: '/trips/$tripId/summary'
      preLoaderRoute: typeof AuthenticatedTripsTripIdSummaryRouteImport
      parentRoute: typeof AuthenticatedTripsTripIdRouteRoute
    }
    '/_authenticated/trips/$tripId/success': {
      id: '/_authenticated/trips/$tripId/success'
      path: '/success'
      fullPath: '/trips/$tripId/success'
      preLoaderRoute: typeof AuthenticatedTripsTripIdSuccessRouteImport
      parentRoute: typeof AuthenticatedTripsTripIdRouteRoute
    }
    '/_authenticated/trips/$tripId/booking': {
      id: '/_authenticated/trips/$tripId/booking'
      path: '/booking'
      fullPath: '/trips/$tripId/booking'
      preLoaderRoute: typeof AuthenticatedTripsTripIdBookingRouteImport
      parentRoute: typeof AuthenticatedTripsTripIdRouteRoute
    }
    '/_authenticated/bookings_/$scope/$id': {
      id: '/_authenticated/bookings_/$scope/$id'
      path: '/bookings/$scope/$id'
      fullPath: '/bookings/$scope/$id'
      preLoaderRoute: typeof AuthenticatedBookingsScopeIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_hotels/hotels/list': {
      id: '/_authenticated/_hotels/hotels/list'
      path: '/hotels/list'
      fullPath: '/hotels/list'
      preLoaderRoute: typeof AuthenticatedHotelsHotelsListRouteImport
      parentRoute: typeof AuthenticatedHotelsRoute
    }
    '/_authenticated/_hotels/_hotel-offer/hotels/$id': {
      id: '/_authenticated/_hotels/_hotel-offer/hotels/$id'
      path: '/hotels/$id'
      fullPath: '/hotels/$id'
      preLoaderRoute: typeof AuthenticatedHotelsHotelOfferHotelsIdRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelOfferRoute
    }
    '/_authenticated/_flights/flights/return/list': {
      id: '/_authenticated/_flights/flights/return/list'
      path: '/flights/return/list'
      fullPath: '/flights/return/list'
      preLoaderRoute: typeof AuthenticatedFlightsFlightsReturnListRouteImport
      parentRoute: typeof AuthenticatedFlightsRoute
    }
    '/_authenticated/_flights/flights/departure/list': {
      id: '/_authenticated/_flights/flights/departure/list'
      path: '/flights/departure/list'
      fullPath: '/flights/departure/list'
      preLoaderRoute: typeof AuthenticatedFlightsFlightsDepartureListRouteImport
      parentRoute: typeof AuthenticatedFlightsRoute
    }
    '/_authenticated/_hotels/_hotel-offer/hotels/$id/travelers': {
      id: '/_authenticated/_hotels/_hotel-offer/hotels/$id/travelers'
      path: '/travelers'
      fullPath: '/hotels/$id/travelers'
      preLoaderRoute: typeof AuthenticatedHotelsHotelOfferHotelsIdTravelersRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelOfferHotelsIdRoute
    }
    '/_authenticated/_hotels/_hotel-offer/hotels/$id/summary': {
      id: '/_authenticated/_hotels/_hotel-offer/hotels/$id/summary'
      path: '/summary'
      fullPath: '/hotels/$id/summary'
      preLoaderRoute: typeof AuthenticatedHotelsHotelOfferHotelsIdSummaryRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelOfferHotelsIdRoute
    }
    '/_authenticated/_hotels/_hotel-offer/hotels/$id/rooms': {
      id: '/_authenticated/_hotels/_hotel-offer/hotels/$id/rooms'
      path: '/rooms'
      fullPath: '/hotels/$id/rooms'
      preLoaderRoute: typeof AuthenticatedHotelsHotelOfferHotelsIdRoomsRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelOfferHotelsIdRoute
    }
    '/_authenticated/_hotels/_hotel-offer/hotels/$id/details': {
      id: '/_authenticated/_hotels/_hotel-offer/hotels/$id/details'
      path: '/details'
      fullPath: '/hotels/$id/details'
      preLoaderRoute: typeof AuthenticatedHotelsHotelOfferHotelsIdDetailsRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelOfferHotelsIdRoute
    }
    '/_authenticated/_hotels/_hotel-offer/hotels/$id/confirmation': {
      id: '/_authenticated/_hotels/_hotel-offer/hotels/$id/confirmation'
      path: '/confirmation'
      fullPath: '/hotels/$id/confirmation'
      preLoaderRoute: typeof AuthenticatedHotelsHotelOfferHotelsIdConfirmationRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelOfferHotelsIdRoute
    }
    '/_authenticated/_hotels/_hotel-offer/hotels/$id/details_/images': {
      id: '/_authenticated/_hotels/_hotel-offer/hotels/$id/details_/images'
      path: '/details/images'
      fullPath: '/hotels/$id/details/images'
      preLoaderRoute: typeof AuthenticatedHotelsHotelOfferHotelsIdDetailsImagesRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelOfferHotelsIdRoute
    }
    '/_authenticated/_hotels/_hotel-offer/hotels/$id/rooms_/$roomToken/images': {
      id: '/_authenticated/_hotels/_hotel-offer/hotels/$id/rooms_/$roomToken/images'
      path: '/rooms/$roomToken/images'
      fullPath: '/hotels/$id/rooms/$roomToken/images'
      preLoaderRoute: typeof AuthenticatedHotelsHotelOfferHotelsIdRoomsRoomTokenImagesRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelOfferHotelsIdRoute
    }
    '/_authenticated/_hotels/_hotel-offer/hotels/$id/details_/images_/fullscreen': {
      id: '/_authenticated/_hotels/_hotel-offer/hotels/$id/details_/images_/fullscreen'
      path: '/details/images/fullscreen'
      fullPath: '/hotels/$id/details/images/fullscreen'
      preLoaderRoute: typeof AuthenticatedHotelsHotelOfferHotelsIdDetailsImagesFullscreenRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelOfferHotelsIdRoute
    }
    '/_authenticated/_flights/_flight-offer/flights/offer/$id/step/final': {
      id: '/_authenticated/_flights/_flight-offer/flights/offer/$id/step/final'
      path: '/flights/offer/$id/step/final'
      fullPath: '/flights/offer/$id/step/final'
      preLoaderRoute: typeof AuthenticatedFlightsFlightOfferFlightsOfferIdStepFinalRouteImport
      parentRoute: typeof AuthenticatedFlightsFlightOfferRoute
    }
    '/_authenticated/_flights/_flight-offer/flights/offer/$id/step/3': {
      id: '/_authenticated/_flights/_flight-offer/flights/offer/$id/step/3'
      path: '/flights/offer/$id/step/3'
      fullPath: '/flights/offer/$id/step/3'
      preLoaderRoute: typeof AuthenticatedFlightsFlightOfferFlightsOfferIdStep3RouteImport
      parentRoute: typeof AuthenticatedFlightsFlightOfferRoute
    }
    '/_authenticated/_flights/_flight-offer/flights/offer/$id/step/2': {
      id: '/_authenticated/_flights/_flight-offer/flights/offer/$id/step/2'
      path: '/flights/offer/$id/step/2'
      fullPath: '/flights/offer/$id/step/2'
      preLoaderRoute: typeof AuthenticatedFlightsFlightOfferFlightsOfferIdStep2RouteImport
      parentRoute: typeof AuthenticatedFlightsFlightOfferRoute
    }
    '/_authenticated/_flights/_flight-offer/flights/offer/$id/step/1': {
      id: '/_authenticated/_flights/_flight-offer/flights/offer/$id/step/1'
      path: '/flights/offer/$id/step/1'
      fullPath: '/flights/offer/$id/step/1'
      preLoaderRoute: typeof AuthenticatedFlightsFlightOfferFlightsOfferIdStep1RouteImport
      parentRoute: typeof AuthenticatedFlightsFlightOfferRoute
    }
    '/_authenticated/_hotels/_hotel-offer/hotels/$id/rooms_/$roomToken/images_/fullscreen': {
      id: '/_authenticated/_hotels/_hotel-offer/hotels/$id/rooms_/$roomToken/images_/fullscreen'
      path: '/rooms/$roomToken/images/fullscreen'
      fullPath: '/hotels/$id/rooms/$roomToken/images/fullscreen'
      preLoaderRoute: typeof AuthenticatedHotelsHotelOfferHotelsIdRoomsRoomTokenImagesFullscreenRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelOfferHotelsIdRoute
    }
  }
}

interface AuthenticatedFlightsFlightOfferRouteChildren {
  AuthenticatedFlightsFlightOfferFlightsOfferIdStep1Route: typeof AuthenticatedFlightsFlightOfferFlightsOfferIdStep1Route
  AuthenticatedFlightsFlightOfferFlightsOfferIdStep2Route: typeof AuthenticatedFlightsFlightOfferFlightsOfferIdStep2Route
  AuthenticatedFlightsFlightOfferFlightsOfferIdStep3Route: typeof AuthenticatedFlightsFlightOfferFlightsOfferIdStep3Route
  AuthenticatedFlightsFlightOfferFlightsOfferIdStepFinalRoute: typeof AuthenticatedFlightsFlightOfferFlightsOfferIdStepFinalRoute
}

const AuthenticatedFlightsFlightOfferRouteChildren: AuthenticatedFlightsFlightOfferRouteChildren =
  {
    AuthenticatedFlightsFlightOfferFlightsOfferIdStep1Route:
      AuthenticatedFlightsFlightOfferFlightsOfferIdStep1Route,
    AuthenticatedFlightsFlightOfferFlightsOfferIdStep2Route:
      AuthenticatedFlightsFlightOfferFlightsOfferIdStep2Route,
    AuthenticatedFlightsFlightOfferFlightsOfferIdStep3Route:
      AuthenticatedFlightsFlightOfferFlightsOfferIdStep3Route,
    AuthenticatedFlightsFlightOfferFlightsOfferIdStepFinalRoute:
      AuthenticatedFlightsFlightOfferFlightsOfferIdStepFinalRoute,
  }

const AuthenticatedFlightsFlightOfferRouteWithChildren =
  AuthenticatedFlightsFlightOfferRoute._addFileChildren(
    AuthenticatedFlightsFlightOfferRouteChildren,
  )

interface AuthenticatedFlightsRouteChildren {
  AuthenticatedFlightsFlightOfferRoute: typeof AuthenticatedFlightsFlightOfferRouteWithChildren
  AuthenticatedFlightsFlightsDepartureListRoute: typeof AuthenticatedFlightsFlightsDepartureListRoute
  AuthenticatedFlightsFlightsReturnListRoute: typeof AuthenticatedFlightsFlightsReturnListRoute
}

const AuthenticatedFlightsRouteChildren: AuthenticatedFlightsRouteChildren = {
  AuthenticatedFlightsFlightOfferRoute:
    AuthenticatedFlightsFlightOfferRouteWithChildren,
  AuthenticatedFlightsFlightsDepartureListRoute:
    AuthenticatedFlightsFlightsDepartureListRoute,
  AuthenticatedFlightsFlightsReturnListRoute:
    AuthenticatedFlightsFlightsReturnListRoute,
}

const AuthenticatedFlightsRouteWithChildren =
  AuthenticatedFlightsRoute._addFileChildren(AuthenticatedFlightsRouteChildren)

interface AuthenticatedHotelsHotelOfferHotelsIdRouteChildren {
  AuthenticatedHotelsHotelOfferHotelsIdConfirmationRoute: typeof AuthenticatedHotelsHotelOfferHotelsIdConfirmationRoute
  AuthenticatedHotelsHotelOfferHotelsIdDetailsRoute: typeof AuthenticatedHotelsHotelOfferHotelsIdDetailsRoute
  AuthenticatedHotelsHotelOfferHotelsIdRoomsRoute: typeof AuthenticatedHotelsHotelOfferHotelsIdRoomsRoute
  AuthenticatedHotelsHotelOfferHotelsIdSummaryRoute: typeof AuthenticatedHotelsHotelOfferHotelsIdSummaryRoute
  AuthenticatedHotelsHotelOfferHotelsIdTravelersRoute: typeof AuthenticatedHotelsHotelOfferHotelsIdTravelersRoute
  AuthenticatedHotelsHotelOfferHotelsIdDetailsImagesRoute: typeof AuthenticatedHotelsHotelOfferHotelsIdDetailsImagesRoute
  AuthenticatedHotelsHotelOfferHotelsIdDetailsImagesFullscreenRoute: typeof AuthenticatedHotelsHotelOfferHotelsIdDetailsImagesFullscreenRoute
  AuthenticatedHotelsHotelOfferHotelsIdRoomsRoomTokenImagesRoute: typeof AuthenticatedHotelsHotelOfferHotelsIdRoomsRoomTokenImagesRoute
  AuthenticatedHotelsHotelOfferHotelsIdRoomsRoomTokenImagesFullscreenRoute: typeof AuthenticatedHotelsHotelOfferHotelsIdRoomsRoomTokenImagesFullscreenRoute
}

const AuthenticatedHotelsHotelOfferHotelsIdRouteChildren: AuthenticatedHotelsHotelOfferHotelsIdRouteChildren =
  {
    AuthenticatedHotelsHotelOfferHotelsIdConfirmationRoute:
      AuthenticatedHotelsHotelOfferHotelsIdConfirmationRoute,
    AuthenticatedHotelsHotelOfferHotelsIdDetailsRoute:
      AuthenticatedHotelsHotelOfferHotelsIdDetailsRoute,
    AuthenticatedHotelsHotelOfferHotelsIdRoomsRoute:
      AuthenticatedHotelsHotelOfferHotelsIdRoomsRoute,
    AuthenticatedHotelsHotelOfferHotelsIdSummaryRoute:
      AuthenticatedHotelsHotelOfferHotelsIdSummaryRoute,
    AuthenticatedHotelsHotelOfferHotelsIdTravelersRoute:
      AuthenticatedHotelsHotelOfferHotelsIdTravelersRoute,
    AuthenticatedHotelsHotelOfferHotelsIdDetailsImagesRoute:
      AuthenticatedHotelsHotelOfferHotelsIdDetailsImagesRoute,
    AuthenticatedHotelsHotelOfferHotelsIdDetailsImagesFullscreenRoute:
      AuthenticatedHotelsHotelOfferHotelsIdDetailsImagesFullscreenRoute,
    AuthenticatedHotelsHotelOfferHotelsIdRoomsRoomTokenImagesRoute:
      AuthenticatedHotelsHotelOfferHotelsIdRoomsRoomTokenImagesRoute,
    AuthenticatedHotelsHotelOfferHotelsIdRoomsRoomTokenImagesFullscreenRoute:
      AuthenticatedHotelsHotelOfferHotelsIdRoomsRoomTokenImagesFullscreenRoute,
  }

const AuthenticatedHotelsHotelOfferHotelsIdRouteWithChildren =
  AuthenticatedHotelsHotelOfferHotelsIdRoute._addFileChildren(
    AuthenticatedHotelsHotelOfferHotelsIdRouteChildren,
  )

interface AuthenticatedHotelsHotelOfferRouteChildren {
  AuthenticatedHotelsHotelOfferHotelsIdRoute: typeof AuthenticatedHotelsHotelOfferHotelsIdRouteWithChildren
}

const AuthenticatedHotelsHotelOfferRouteChildren: AuthenticatedHotelsHotelOfferRouteChildren =
  {
    AuthenticatedHotelsHotelOfferHotelsIdRoute:
      AuthenticatedHotelsHotelOfferHotelsIdRouteWithChildren,
  }

const AuthenticatedHotelsHotelOfferRouteWithChildren =
  AuthenticatedHotelsHotelOfferRoute._addFileChildren(
    AuthenticatedHotelsHotelOfferRouteChildren,
  )

interface AuthenticatedHotelsRouteChildren {
  AuthenticatedHotelsHotelOfferRoute: typeof AuthenticatedHotelsHotelOfferRouteWithChildren
  AuthenticatedHotelsHotelsListRoute: typeof AuthenticatedHotelsHotelsListRoute
}

const AuthenticatedHotelsRouteChildren: AuthenticatedHotelsRouteChildren = {
  AuthenticatedHotelsHotelOfferRoute:
    AuthenticatedHotelsHotelOfferRouteWithChildren,
  AuthenticatedHotelsHotelsListRoute: AuthenticatedHotelsHotelsListRoute,
}

const AuthenticatedHotelsRouteWithChildren =
  AuthenticatedHotelsRoute._addFileChildren(AuthenticatedHotelsRouteChildren)

interface AuthenticatedTripsTripIdRouteRouteChildren {
  AuthenticatedTripsTripIdBookingRoute: typeof AuthenticatedTripsTripIdBookingRoute
  AuthenticatedTripsTripIdSuccessRoute: typeof AuthenticatedTripsTripIdSuccessRoute
  AuthenticatedTripsTripIdSummaryRoute: typeof AuthenticatedTripsTripIdSummaryRoute
  AuthenticatedTripsTripIdTravellersRoute: typeof AuthenticatedTripsTripIdTravellersRoute
  AuthenticatedTripsTripIdIndexRoute: typeof AuthenticatedTripsTripIdIndexRoute
}

const AuthenticatedTripsTripIdRouteRouteChildren: AuthenticatedTripsTripIdRouteRouteChildren =
  {
    AuthenticatedTripsTripIdBookingRoute: AuthenticatedTripsTripIdBookingRoute,
    AuthenticatedTripsTripIdSuccessRoute: AuthenticatedTripsTripIdSuccessRoute,
    AuthenticatedTripsTripIdSummaryRoute: AuthenticatedTripsTripIdSummaryRoute,
    AuthenticatedTripsTripIdTravellersRoute:
      AuthenticatedTripsTripIdTravellersRoute,
    AuthenticatedTripsTripIdIndexRoute: AuthenticatedTripsTripIdIndexRoute,
  }

const AuthenticatedTripsTripIdRouteRouteWithChildren =
  AuthenticatedTripsTripIdRouteRoute._addFileChildren(
    AuthenticatedTripsTripIdRouteRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedFlightsRoute: typeof AuthenticatedFlightsRouteWithChildren
  AuthenticatedHotelsRoute: typeof AuthenticatedHotelsRouteWithChildren
  AuthenticatedBookingsRoute: typeof AuthenticatedBookingsRoute
  AuthenticatedChatRoute: typeof AuthenticatedChatRoute
  AuthenticatedFlightsExternalRoute: typeof AuthenticatedFlightsExternalRoute
  AuthenticatedHotelsExternalRoute: typeof AuthenticatedHotelsExternalRoute
  AuthenticatedTravelersRoute: typeof AuthenticatedTravelersRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedTripsTripIdRouteRoute: typeof AuthenticatedTripsTripIdRouteRouteWithChildren
  AuthenticatedBookingsScopeIdRoute: typeof AuthenticatedBookingsScopeIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedFlightsRoute: AuthenticatedFlightsRouteWithChildren,
  AuthenticatedHotelsRoute: AuthenticatedHotelsRouteWithChildren,
  AuthenticatedBookingsRoute: AuthenticatedBookingsRoute,
  AuthenticatedChatRoute: AuthenticatedChatRoute,
  AuthenticatedFlightsExternalRoute: AuthenticatedFlightsExternalRoute,
  AuthenticatedHotelsExternalRoute: AuthenticatedHotelsExternalRoute,
  AuthenticatedTravelersRoute: AuthenticatedTravelersRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedTripsTripIdRouteRoute:
    AuthenticatedTripsTripIdRouteRouteWithChildren,
  AuthenticatedBookingsScopeIdRoute: AuthenticatedBookingsScopeIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
